export default "__VITE_ASSET__BQvc6lB1__"